import _slicedToArray from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { isNativeAudioNode } from '../guards/native-audio-node';
export var wrapAudioNodeDisconnectMethod = function wrapAudioNodeDisconnectMethod(nativeAudioNode) {
  var connections = new Map();
  nativeAudioNode.connect = function (connect) {
    // tslint:disable-next-line:invalid-void no-inferrable-types
    return function (destination) {
      var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var input = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var returnValue = isNativeAudioNode(destination) ? connect(destination, output, input) : connect(destination, output);
      // Save the new connection only if the calls to connect above didn't throw an error.
      var connectionsToDestination = connections.get(destination);
      if (connectionsToDestination === undefined) {
        connections.set(destination, [{
          input: input,
          output: output
        }]);
      } else {
        if (connectionsToDestination.every(function (connection) {
          return connection.input !== input || connection.output !== output;
        })) {
          connectionsToDestination.push({
            input: input,
            output: output
          });
        }
      }
      return returnValue;
    };
  }(nativeAudioNode.connect.bind(nativeAudioNode));
  nativeAudioNode.disconnect = function (disconnect) {
    return function (destinationOrOutput, output, input) {
      disconnect.apply(nativeAudioNode);
      if (destinationOrOutput === undefined) {
        connections.clear();
      } else if (typeof destinationOrOutput === 'number') {
        var _iterator = _createForOfIteratorHelper(connections),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              destination = _step$value[0],
              connectionsToDestination = _step$value[1];
            var filteredConnections = connectionsToDestination.filter(function (connection) {
              return connection.output !== destinationOrOutput;
            });
            if (filteredConnections.length === 0) {
              connections.delete(destination);
            } else {
              connections.set(destination, filteredConnections);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (connections.has(destinationOrOutput)) {
        if (output === undefined) {
          connections.delete(destinationOrOutput);
        } else {
          var _connectionsToDestination = connections.get(destinationOrOutput);
          if (_connectionsToDestination !== undefined) {
            var _filteredConnections = _connectionsToDestination.filter(function (connection) {
              return connection.output !== output && (connection.input !== input || input === undefined);
            });
            if (_filteredConnections.length === 0) {
              connections.delete(destinationOrOutput);
            } else {
              connections.set(destinationOrOutput, _filteredConnections);
            }
          }
        }
      }
      var _iterator2 = _createForOfIteratorHelper(connections),
        _step2;
      try {
        var _loop = function _loop() {
          var _step2$value = _slicedToArray(_step2.value, 2),
            destination = _step2$value[0],
            connectionsToDestination = _step2$value[1];
          connectionsToDestination.forEach(function (connection) {
            if (isNativeAudioNode(destination)) {
              nativeAudioNode.connect(destination, connection.output, connection.input);
            } else {
              nativeAudioNode.connect(destination, connection.output);
            }
          });
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
  }(nativeAudioNode.disconnect);
};